<template>
  <v-dialog v-model="open" persistent max-width="500">
    <v-card>

      <v-card-title>Send Proforma Invoice</v-card-title>

      <v-card-text class="pb-4">Are you sure you want to send the proforma invoice to {{currentAccount.email_address}}?</v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="primary" small @click="sendProformaInvoice()">OK</v-btn>
        <v-btn color="primary" small outlined @click="closeDialog()">CANCEL</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog> 
</template>

<script>
  import {mapState, mapActions} from 'vuex';

  export default {
    props: {
      open: Boolean,
      id: [String, Number],
    },

    computed: {
      ...mapState('accounts', ['currentAccount'])
    },

    methods: {
      ...mapActions('retention', ['sendCustomerProformaInvoice']),

      async sendProformaInvoice() {
        await this.sendCustomerProformaInvoice(this.id);
        this.closeDialog();
      },
      
      closeDialog() {
        this.$emit('closeDialog');
      }
    }
  }
</script>